import React, { FC, useContext } from 'react';

import { Cards } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-index';
import LocaleContext from 'lib/locale-context';
const type = '2-up';

export const Landing2CardsContainer: FC = () => {
    const lang = useContext(LocaleContext);

    return (
        <Cards
            type={type}
            size="desktop"
            cards={[
                {
                    type,
                    title: lexemes.lxPageIndex2CardsBumbleTitle,
                    description: lexemes.lxPageIndex2CardsBumbleDescription,
                    link: `/${lang}/date`,
                    linkText: lexemes.lxPageIndex2CardsBumbleLink,
                    image: {
                        src: '/project-love/assets/bumble-date.jpg',
                        alt: '',
                        style: {
                            objectFit: 'cover',
                            objectPosition: 'bottom',
                            background: '#FCFCFC',
                        },
                    },
                },
                {
                    type,
                    title: 'BFF',
                    description: lexemes.lxPageIndex2CardsBFFDescription,
                    link: `/${lang}/bff`,
                    linkText: lexemes.lxPageIndex2CardsBFFLink,
                    image: {
                        src: '/project-love/assets/bff.jpg',
                        alt: '',
                        style: {
                            objectFit: 'cover',
                            objectPosition: 'bottom',
                        },
                    },
                    backgroundColor: 'light-yellow',
                },
            ]}
        />
    );
};
